    angular.module('auth', ['core'])
        .factory('Principal', function ($q, $rootScope, Account) {
            var _identity,
                _identityPromise,
                _authenticated = false;

            var service = {
                authenticate: authenticate,
                hasAnyAuthority: hasAnyAuthority,
                hasAnyAuthorityPromise: hasAnyAuthorityPromise,
                hasAuthority: hasAuthority,
                hasAllAuthorities: hasAllAuthorities,
                identity: identity,
                isAuthenticated: isAuthenticated,
                isIdentityResolved: isIdentityResolved,
                currentUser: currentUser,
                refreshIdentity: refreshIdentity
            };

            return service;

            function authenticate(identity) {
                _identity = identity;
                _authenticated = identity !== null;
            }

            function currentUser() {
                var deferred = $q.defer();


                if (angular.isDefined(_identity)) {
                    getAccountThen();
                }

                this.identity()
                    .then(getAccountThen)
                    .catch(getAccountCatch);

                return deferred.promise;

                function getAccountThen() {
                    var user = {
                        id: _identity.id,
                        login: _identity.login,
                        fullName: _identity.fullName,
                        avatar: _identity.avatar,
                    };
                    deferred.resolve(user);
                }

                function getAccountCatch() {
                    deferred.resolve(undefined);
                }
            }

            function hasAnyAuthority(authorities) {
                if (!_authenticated || !_identity || !_identity.authorities) {
                    return false;
                }

                return authorities.some(it => _identity.authorities.indexOf(it) !== -1)
            }

            function hasAnyAuthorityPromise(authorities) {
                if (!_authenticated) {
                    return $q.when(false);
                }

                return this.identity().then(function (_id) {
                    for (var i = 0; i < authorities.length; i++) {
                        if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                            return true;
                        }
                    }
                    return false;
                }, function () {
                    return false;
                });
            }

            function hasAuthority(authority) {
                if (!_authenticated) {
                    return $q.when(false);
                }

                return this.identity().then(function (_id) {
                    return _id.authorities && _id.authorities.indexOf(authority) !== -1;
                }, function () {
                    return false;
                });
            }

            function hasAllAuthorities(authorities) {
                if (!_authenticated || !_identity || !_identity.authorities) {
                    return false;
                }

                return authorities.every(it => _identity.authorities.indexOf(it) !== -1)
            }

            function identity(force) {
                if (force === true) {
                    if (angular.isDefined(_identityPromise)) {
                        return _identityPromise;
                    }
                    _identityPromise = Account.currentAccount().$promise
                        .then(getAccountThen)
                        .catch(getAccountCatch)
                        .finally(function () {
                            _identityPromise = undefined;
                        });
                    return _identityPromise;
                }

                if (angular.isDefined(_identityPromise)) {
                    return _identityPromise;
                }

                // check and see if we have retrieved the identity data from the server.
                // if we have, reuse it by immediately resolving
                if (angular.isDefined(_identity)) {
                    return $q.when(_identity);
                }

                // retrieve the identity data from the server, update the identity object, and then resolve.
                _identityPromise = Account.currentAccount().$promise
                    .then(getAccountThen)
                    .catch(getAccountCatch)
                    .finally(function () {
                        _identityPromise = undefined;
                    });
                return _identityPromise;

                function getAccountThen(account) {
                    // _identity = account.data;
                    _identity = account;
                    _authenticated = true;
                    return _identity;
                }

                function getAccountCatch() {
                    _identity = null;
                    _authenticated = false;
                    return _identity;
                }
            }

            function refreshIdentity() {
                return identity(true).then(function (account) {
                    $rootScope.$broadcast('authenticationChanged');
                    return account;
                });
            }

            function isAuthenticated() {
                return _authenticated;
            }

            function isIdentityResolved() {
                return angular.isDefined(_identity);
            }
        })
        .directive('hasAnyAuthority', function (Principal) {
            return {
                restrict: 'A',
                link: linkFunc
            };

            function linkFunc(scope, element, attrs) {
                var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');
                var requiredAuthorities = attrs.requiresAllAuthorities ? attrs.requiresAllAuthorities.replace(/\s+/g, '').split(',') : [];

                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function () {
                        var result = Principal.hasAnyAuthority(authorities) && (requiredAuthorities.length === 0 || Principal.hasAllAuthorities(requiredAuthorities));
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    };

                if (authorities.length > 0) {
                    defineVisibility();

                    scope.$watch(function () {
                        // return Principal.account();
                        return Principal.isIdentityResolved();
                    }, function () {
                        defineVisibility();
                    });

                    var unwatchAuthenticationChanged = scope.$on('authenticationChanged', function () {
                        defineVisibility();
                    });
                    scope.$on('$destroy', unwatchAuthenticationChanged);
                }
            }
        })
        .directive('hasAllAuthorities', function (Principal) {
            return {
                restrict: 'A',
                link: linkFunc
            };

            function linkFunc(scope, element, attrs) {
                var authorities = attrs.hasAllAuthorities.replace(/\s+/g, '').split(',');

                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function () {
                        var result = Principal.hasAllAuthorities(authorities);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    };

                if (authorities.length > 0) {
                    defineVisibility();

                    scope.$watch(function () {
                        // return Principal.account();
                        return Principal.isIdentityResolved();
                    }, function () {
                        defineVisibility();
                    });

                    var unwatchAuthenticationChanged = scope.$on('authenticationChanged', function () {
                        defineVisibility();
                    });
                    scope.$on('$destroy', unwatchAuthenticationChanged);
                }
            }
        })
        .factory('AuthServerProvider', function ($http) {
            var service = {
                getToken: getToken,
                hasValidToken: hasValidToken,
                login: login,
                loginAs: loginAs,
                exitUser: exitUser,
                logout: logout
            };

            return service;

            function getToken() {
                // var token = $localStorage.authenticationToken;
                // return token;
            }

            function hasValidToken() {
                //     var token = this.getToken();
                //     return !!token;
            }

            function login(credentials) {
                var data = 'j_username=' + encodeURIComponent(credentials.username) +
                    '&j_password=' + encodeURIComponent(credentials.password) +
                    '&remember-me=' + credentials.rememberMe + '&submit=Login';

                return $http.post('/crm/api/authentication', data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function (response) {
                    return response;
                });
            }

            function loginAs(username) {
                var data = 'j_username=' + encodeURIComponent(username);

                return $http.post('/crm/api/switch_user', data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function (response) {
                    return response;
                });
            }

            function exitUser() {
                return $http.post('/crm/api/exit_user', {}, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function (response) {
                    return response;
                });
            }

            function logout() {
                // logout from the server
                $http.post('/crm/api/logout').then(function (response) {
                    // delete $localStorage.authenticationToken;
                    // to get a new csrf token call the api
                    $http.get('/crm/api/account');
                    return response;
                });
            }
        })
        .service('Auth', function (AuthServerProvider, $rootScope, $q, Principal) {
            function logout() {
                AuthServerProvider.logout();
                Principal.authenticate(null);
            }

            function login(credentials, callback) {
                var cb = callback || angular.noop;
                var deferred = $q.defer();

                AuthServerProvider.login(credentials)
                    .then(loginThen)
                    .catch(function (err) {
                        // this.logout();
                        Principal.authenticate(null);
                        deferred.reject(err);
                        return cb(err);
                    }.bind(this));

                function loginThen(data) {
                    Principal.identity(true).then(function (account) {
                        //     // After the login the language will be changed to
                        //     // the language selected by the user during his registration
                        //     if (account!== null) {
                        //         $translate.use(account.langKey).then(function () {
                        //             $translate.refresh();
                        //         });
                        //     }
                        $rootScope.$broadcast('authenticationSuccess');
                        $rootScope.$broadcast('authenticationChanged');
                        deferred.resolve(data);
                    });
                    return cb();
                }

                return deferred.promise;
            }

            function loginAs(username, callback) {
                var cb = callback || angular.noop;
                var deferred = $q.defer();

                AuthServerProvider.loginAs(username)
                    .then(loginThen)
                    .catch(function (err) {
                        this.logout();
                        deferred.reject(err);
                        return cb(err);
                    }.bind(this));

                function loginThen(data) {
                    Principal.identity(true).then(function (account) {
                        $rootScope.$broadcast('authenticationSuccess');
                        $rootScope.$broadcast('authenticationChanged');
                        deferred.resolve(data);
                        return cb();
                    });
                }

                return deferred.promise;
            }

            function exitUser(callback) {
                var cb = callback || angular.noop;
                var deferred = $q.defer();

                AuthServerProvider.exitUser()
                    .then(then)
                    .catch(function (err) {
                        this.logout();
                        deferred.reject(err);
                        return cb(err);
                    }.bind(this));

                function then(data) {
                    Principal.identity(true).then(function (account) {
                        $rootScope.$broadcast('authenticationSuccess');
                        $rootScope.$broadcast('authenticationChanged');
                        deferred.resolve(data);
                    });
                    return cb();
                }

                return deferred.promise;
            }
            function authorize (force) {
                return Principal.identity(force).then(authThen);

                function authThen () {
                    var isAuthenticated = Principal.isAuthenticated();
                }
            }

            return {
                authorize: authorize,
                login: login,
                logout: logout,
                loginAs: loginAs,
                exitUser: exitUser
            }
        });
